(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellerive-vip-black-friday"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('blv-vip-signup')) {
  customElements.define('blv-vip-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.bound = true;
      this.fields = this.querySelector('fieldset');
      this.status = this.querySelector('[role="status"]');
      this.button = this.querySelector('button');
      this.fields.disabled = false;
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.pending || !this.form.reportValidity()) return;
        const site = this.dataset.site;
        const list = this.dataset.list;
        if (!/^[a-zA-Z0-9]{6}$/.test(site || '') || !/^[a-zA-Z0-9]{6}$/.test(list || '')) {
          this.status.textContent = this.dataset.error;
          return;
        }
        let destination;
        try {
          if (!this.dataset.redirect || !this.dataset.redirect.trim()) throw new Error('Missing confirmation URL');
          destination = new URL(this.dataset.redirect, window.location.href);
          if (!['https:', 'http:'].includes(destination.protocol)) throw new Error('Invalid confirmation URL');
        } catch (error) {
          this.status.textContent = this.dataset.error;
          return;
        }
        const email = this.form.elements.email.value.trim();
        this.pending = true;
        this.fields.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        const label = this.button.textContent;
        this.button.textContent = this.dataset.busy;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(site), {
            method: 'POST',
            credentials: 'omit',
            headers: {'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15'},
            signal: controller.signal,
            body: JSON.stringify({data: {
              type: 'subscription',
              attributes: {custom_source: 'Bellerive VIP Black Friday', profile: {data: {type: 'profile', attributes: {email, subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}}}}},
              relationships: {list: {data: {type: 'list', id: list}}}
            }})
          });
          if (response.status !== 202) throw new Error('Subscription not accepted');
          window.location.assign(destination.href);
          this.redirecting = true;
        } catch (error) {
          this.status.textContent = this.dataset.error;
        } finally {
          clearTimeout(timer);
          if (!this.redirecting) {
            this.pending = false;
            this.fields.disabled = false;
            this.form.removeAttribute('aria-busy');
            this.button.textContent = label;
          }
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
